import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import ReactSwitch from 'react-switch';
import { TCITooltip } from '@/components/ui/Tooltip';
import I18n from '@/modules/i18n';
import styles from './Switch.module.scss';

const INFO_BUTTON = 'tw-inline-flex tw-border-0 tw-bg-transparent tw-p-0 tw-align-baseline';

export default class Switch extends Component {
  static propTypes = {
    actions: PropTypes.func,
    ajaxPath: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string,
    displayLabelFirst: PropTypes.bool,
    label: PropTypes.string.isRequired,
    labelTooltip: PropTypes.string,
    model: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    actions: () => {},
    disabled: false,
    disabledTooltip: null,
    displayLabelFirst: true,
    labelTooltip: null,
    onClick: () => {},
  };

  constructor(props) {
    super(props);
    this.state = { checked: props.checked };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({ checked });
    const data = {};
    data[this.props.model] = {};
    data[this.props.model][this.props.name] = checked;
    Axios.patch(this.props.ajaxPath, data);
    this.props.onClick();
  }

  // AIDEV-NOTE: react-switch puts `disabled` on its own <input>, so a disabled toggle leaves the
  // tab order and this tooltip can only ever open on hover. The reason is repeated in the info
  // button beside the label, which is the keyboard and screen-reader path -- don't "deduplicate"
  // the two: they serve different inputs. See PLAT-18156.
  disabledReason() {
    return this.props.disabled ? this.props.disabledTooltip : null;
  }

  renderSwitch() {
    const switchTooltip = this.disabledReason();
    const toggle = (
      <div className="inline">
        <ReactSwitch
          onChange={this.handleChange}
          checked={this.state.checked}
          onColor="#522e91"
          offColor="#cccccc"
          checkedIcon={false}
          uncheckedIcon={false}
          height={24}
          width={48}
          handleDiameter={20}
          disabled={this.props.disabled}
        />
      </div>
    );

    if (!switchTooltip) return toggle;

    return (
      <TCITooltip>
        <TCITooltip.Trigger asChild>
          {toggle}
        </TCITooltip.Trigger>
        <TCITooltip.Content>
          {switchTooltip}
        </TCITooltip.Content>
      </TCITooltip>
    );
  }

  renderLabelTooltip() {
    const content = [this.props.labelTooltip, this.disabledReason()].filter(Boolean).join(' ');

    if (!content) return null;

    return (
      <TCITooltip>
        {/* preventDefault stops the click reaching the <label> and toggling the switch. */}
        <TCITooltip.Trigger
          aria-label={I18n.t('more_info')}
          className={INFO_BUTTON}
          type="button"
          onClick={e => e.preventDefault()}
        >
          <i aria-hidden="true" className="fa fa-question-circle slide-digital-only-tooltip" />
        </TCITooltip.Trigger>
        <TCITooltip.Content>
          {content}
        </TCITooltip.Content>
      </TCITooltip>
    );
  }

  renderActions() {
    if (!this.props.actions) return null;

    return (this.props.actions);
  }

  render() {
    return (
      <label className={styles.container}>
        {!this.props.displayLabelFirst && this.renderSwitch()}
        <span>
          {`${this.props.label} `}
          {this.renderLabelTooltip()}
          {this.renderActions()}
        </span>
        {this.props.displayLabelFirst && this.renderSwitch()}
      </label>
    );
  }
}
